import React from 'react';

export function TermsContent() {
  return (
    <div className="space-y-6 text-gray-700 dark:text-gray-300 text-sm">
      <section>
        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">1. ACEPTACIÓN DE LOS TÉRMINOS</h2>
        <p>Al acceder y utilizar La Granja Vota (lacasavota.com), usted acepta estar sujeto a estos Términos y Condiciones. Si no está de acuerdo con alguna parte de estos términos, no debe usar nuestro servicio.</p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">2. DESCRIPCIÓN DEL SERVICIO</h2>
        <p>La Granja Vota es una plataforma NO OFICIAL de entretenimiento que permite a los usuarios participar en encuestas y votaciones sobre el programa "La Granja VIP".</p>
        <p className="mt-2 font-semibold">IMPORTANTE: Esta plataforma no tiene afiliación oficial con TV Azteca, Azteca Uno, Fremantle, Disney+, o cualquier otra entidad relacionada con el programa oficial.</p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">3. REGISTRO Y CUENTA DE USUARIO</h2>
        <ul className="list-disc list-inside space-y-2">
          <li>Debe proporcionar información veraz y actualizada</li>
          <li>Es responsable de mantener la confidencialidad de su cuenta</li>
          <li>Solo se permite una cuenta por persona</li>
          <li>Nos reservamos el derecho de suspender cuentas que violen estos términos</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">4. USO ACEPTABLE</h2>
        <p className="font-semibold mb-2">ESTÁ PROHIBIDO:</p>
        <ul className="list-disc list-inside space-y-2">
          <li>Crear múltiples cuentas para manipular votaciones</li>
          <li>Usar bots, scripts o métodos automatizados</li>
          <li>Comportarse de manera abusiva o acosadora</li>
          <li>Intentar hackear o comprometer la seguridad del sitio</li>
          <li>Usar el servicio para actividades ilegales</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">5. VOTACIONES Y PUNTOS</h2>
        <ul className="list-disc list-inside space-y-2">
          <li>Las votaciones son solo para entretenimiento</li>
          <li>Los resultados NO afectan el programa oficial</li>
          <li>Los puntos no tienen valor monetario</li>
          <li>Nos reservamos el derecho de invalidar votos fraudulentos</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">6. CONTENIDO DEL USUARIO</h2>
        <ul className="list-disc list-inside space-y-2">
          <li>Usted mantiene los derechos de su contenido</li>
          <li>Nos otorga licencia para usar, mostrar y distribuir su contenido en la plataforma</li>
          <li>No publicar contenido ofensivo, ilegal o que infrinja derechos de terceros</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">7. PRIVACIDAD</h2>
        <p>Su privacidad es importante. Consulte nuestra Política de Privacidad para entender cómo recopilamos y usamos su información.</p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">8. LIMITACIÓN DE RESPONSABILIDAD</h2>
        <ul className="list-disc list-inside space-y-2">
          <li>El servicio se proporciona "tal como está"</li>
          <li>No garantizamos disponibilidad continua</li>
          <li>No somos responsables por pérdidas directas o indirectas</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">9. MODIFICACIONES</h2>
        <p>Nos reservamos el derecho de modificar estos términos en cualquier momento. Los cambios entrarán en vigor inmediatamente después de su publicación.</p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">10. TERMINACIÓN</h2>
        <p>Podemos suspender o terminar su acceso al servicio en cualquier momento, con o sin causa.</p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">11. LEY APLICABLE</h2>
        <p>Estos términos se rigen por las leyes de México. Cualquier disputa será resuelta en los tribunales competentes de México.</p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">12. CONTACTO</h2>
        <p>Para preguntas sobre estos términos, contacte: <a href="mailto:lagranjavota@gmail.com" className="text-violet-600 dark:text-violet-400 hover:underline">lagranjavota@gmail.com</a></p>
      </section>
    </div>
  );
}
